import { css } from '@emotion/css';

export const cardContainerClassName = css({
  height: '100%',
  position: 'relative',
});

export const cardOffsetClassName = css({
  top: 68, // navbar height
});
